<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>托管学院</h1>
        <span class="icon-right pull-right icon-menu text-hide" @click="isHideTypeList = false">分类</span>
      </div>
      <div class="liner"></div>
    </div>


    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page" v-infinite-scroll="loadBottom"
    infinite-scroll-disabled="isGetting"
    infinite-scroll-distance="150">

      <div class="favorite">
        <ul class="list-group-item large ">
          <li class="list-group" v-for="item in infomationList">
            <div class="liner"></div>
            <router-link class="group-link clearfix" :to="{'path': '/information/detail/' + item.contentId}">
              <img class="pull-right" :src="item.contentImage ? baseAcessPath + item.contentImage : img_default" width="100" height="75" />
              <span class="block group-txt font-12">
                <span class="tit font-16">{{item.contentTitle}}</span>
                <span class="data gray">{{new Date(item.publishTime).format('yyyy-MM-dd')}}</span>
              </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    </mt-loadmore>

     <!-- 资源分类 -->
    <div class="maskdiv" v-show="!isHideTypeList" @click="isHideTypeList = true">
      <div class="slider" @click.stop>
        <strong class="tit">资源分类</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul>
            <li @click="typeId = '', selectInfoType()">
              <div class="clearfix group-link"><span class="pull-left">全部</span>
              <template v-if="'' == typeId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
            <li v-for="item in infoTypeList" @click="typeId = item.typeId, selectInfoType()">
              <div class="clearfix group-link"><span class="pull-left">{{item.typeName}}</span>
              <template v-if="item.typeId == typeId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
export default {
  data () {
    return {
      img_default: require('../../assets/images/ic_no_image.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      offset: 0,
      curcheId: 0,
      teacherId: 0,
      isGetting: true, // 是否正在获取数据中
      isOver: false, // 是否是没有数据获取了
      infocontent_list_para: service.setPara('tinfocontentList'),
      get_info_type_para: service.setPara('getInfoType'),
      infomationList: [],
      refreshDate: '',
      baseAcessPath: '',
      infoTypeList: [],
      isHideTypeList: true,
      typeId: '',
      scrollTop: 0,
      localStorage_refreshDate: 0,
      cacheName: 'informationList',
      bottomStatus: ''
    }
  },
  mounted: function () {
    this.curcheId = this.cookie_login_data.curcheId
    this.teacherId = this.cookie_login_data.teacherId

    this.refreshDate = new Date().format('yyyyMMddhhmmss')
    /* this.sel_score_para.curcheId = this.curcheId
    this.sel_score_para.teacherId = this.teacherId */

    // 获取缓存数据
    let obj = window.localStorage[this.cacheName]
    let flag = true
    if (obj) {
      obj = JSON.parse(obj)
      if ((new Date().getTime() - obj.refreshDate) < 1800 * 1000) { // 30分钟刷一下
        this.infomationList = obj.infomationList
        this.infoTypeList = obj.infoTypeList
        this.infocontent_list_para = obj.infocontent_list_para
        this.isOver = obj.isOver
        this.typeId = obj.typeId
        this.baseAcessPath = obj.baseAcessPath
        this.localStorage_refreshDate = obj.refreshDate
        flag = false
        this.$nextTick(function () {
          this.isGetting = false
        })
      }
    }
    if (flag) {
      this.infocontent_list_para.offset = this.offset
      this.infocontent_list_para.typeId = this.typeId
      this.infocontent_list_para.refreshDate = this.refreshDate
      this.tinfocontentList(true)
      this.getInfoType()
    }

    // this.isScrollBottom()
  },
  methods: {
    loadTop (id) {
      this.offset = 0
      this.infocontent_list_para.offset = 0
      this.isOver = false
      this.infomationList = []
      this.tinfocontentList()
      this.$refs.loadmore.onTopLoaded(id)
    },
    loadBottom () {
      if (this.isOver || this.isGetting) {
        return
      }
      this.offset++
      this.infocontent_list_para.offset = this.offset
      this.infocontent_list_para.refreshDate = this.refreshDate
      this.tinfocontentList()
    },
    tinfocontentList (isIndicator = false) { // 获取资源列表
      this.isGetting = true

      let that = this
      let obj = {context: this, para: this.infocontent_list_para, isIndicator: isIndicator, successFun: (response) => {
        if (response.data.returnList.length == 0) {
          that.isOver = true
        } else {
          // that.refreshDate = response.data.data.refreshDate
          that.baseAcessPath = response.data.baseAcessPath
          var list = response.data.returnList
          that.infomationList = that.infomationList.concat(list)
          that.$nextTick(function () {
            that.isGetting = false
            // $('.list-group-item img').lazyload()
          })
        }
      }}
      service.request(obj)
    },
    getInfoType: function () { // 获取资源类别
      this.get_info_type_para.curcheId = this.curcheId

      let that = this
      let obj = {context: this, para: this.get_info_type_para, successFun: (response) => {
        that.infoTypeList = response.data
      }}
      service.request(obj)
    },
    selectInfoType: function () {
      this.isOver = false
      this.offset = 0
      this.infocontent_list_para.isOver = false
      this.infocontent_list_para.offset = 0
      this.infocontent_list_para.typeId = this.typeId
      this.isHideTypeList = true
      this.infomationList = []
      this.tinfocontentList()
    }
  },
  beforeDestroy: function () {
    if (this.infomationList.length > 0) {
      // 保存缓存数据
      let obj = {}
      // obj.scrollTop = this.scrollTop
      // if (this.infomationList.length > 50) {
      //   obj.scrollTop = 0
      //   this.infocontent_list_para.offset = 0
      //   this.infomationList.splice(50, this.infomationList.length - 50)
      // }
      obj.infomationList = this.infomationList
      obj.infoTypeList = this.infoTypeList
      obj.infocontent_list_para = this.infocontent_list_para
      obj.isOver = this.isOver
      obj.typeId = this.typeId
      obj.baseAcessPath = this.baseAcessPath
      obj.refreshDate = this.localStorage_refreshDate || new Date().getTime()
      window.localStorage[this.cacheName] = JSON.stringify(obj)
    }
  }
}
</script>



// WEBPACK FOOTER //
// InformationList.vue?0f7b5957